const selectors = {
  swiperRoot: ".js-collection-cg-swiper",
  next: ".swiper-button-next",
  prev: ".swiper-button-prev",
  pagination: ".swiper-pagination",
  config: "[data-collection-cg-config]",
};

class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperRoot = null;
    this.swiper = null;

    this._isInitialized = false;
    this._waitAttempts = 0;
    this._waitTimer = null;

    this._mql = null;
    this._onMqlChange = null;
  }

  connectedCallback() {
    this.swiperRoot = this.querySelector(selectors.swiperRoot);
    if (!this.swiperRoot) return;

    this.initWhenReady();
  }

  disconnectedCallback() {
    this.teardown();
  }

  teardown() {
    if (this._waitTimer) {
      clearTimeout(this._waitTimer);
      this._waitTimer = null;
    }

    if (this._mql && this._onMqlChange) {
      // Safari compatibility (removeEventListener may not exist on older versions)
      if (this._mql.removeEventListener) this._mql.removeEventListener("change", this._onMqlChange);
      else this._mql.removeListener(this._onMqlChange);
    }
    this._mql = null;
    this._onMqlChange = null;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this._isInitialized = false;
    this._waitAttempts = 0;
  }

  initWhenReady() {
    if (this._isInitialized) return;

    if (typeof window.Swiper !== "function") {
      this._waitAttempts += 1;
      if (this._waitAttempts > 100) return;

      this._waitTimer = setTimeout(() => {
        this._waitTimer = null;
        if (!this.isConnected) return;
        this.initWhenReady();
      }, 50);

      return;
    }

    this._isInitialized = true;
    this.init();
  }

  init() {
    if (typeof window.Swiper !== "function") return;

    this._mql = window.matchMedia(`(min-width: 768px)`);
    this._onMqlChange = () => {
      if (!this.isConnected) return;
      this._mql.matches ? this.destroySwiper() : this.createSwiper();
    };

    if (this._mql.addEventListener) this._mql.addEventListener("change", this._onMqlChange);
    else this._mql.addListener(this._onMqlChange);

    this._mql.matches ? this.destroySwiper() : this.createSwiper();
  }

  createSwiper() {
    if (this.swiper) return;

    this.swiper = new window.Swiper(this.swiperRoot, {
      initialSlide: 1,
      slidesPerView: 1.6,
      slidesPerGroup: 1,
      loop: true,
      spaceBetween: 16,
      speed: 900,
      watchOverflow: true,
      a11y: { enabled: true },
      centeredSlides: true,
      breakpoints: {
        768: { spaceBetween: 25, slidesPerView: 2 },
        1024: { spaceBetween: 25, slidesPerView: 2.6 },
      },
    });
  }

  destroySwiper() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get("collection-carousel")) {
  customElements.define("collection-carousel", CollectionCarousel);
}
